import { branding } from "../config";

export default function CallToAction({ cta }) {
    if (!cta?.enabled || !cta?.header) {
        return null;
    }

    return (
        <div
            style={{
                marginBottom: "30px",
                padding: "30px 40px",
                background: `linear-gradient(135deg, ${branding.primaryColor} 0%, ${branding.secondaryColor || '#004466'} 100%)`,
                color: "white",
                borderRadius: "12px",
                textAlign: "center",
                boxShadow: "0 6px 20px rgba(0, 0, 0, 0.15)",
            }}
        >
            <h3
                style={{
                    fontWeight: "700",
                    marginBottom: "20px",
                    fontSize: "1.75rem",
                    letterSpacing: "0.5px",
                    color: "white",
                }}
            >
                {cta.header}
            </h3>
            {cta.description && (
                <p
                    style={{
                        fontSize: "1.1rem",
                        marginBottom: "30px",
                        lineHeight: "1.6",
                        maxWidth: "700px",
                        margin: "0 auto 30px auto",
                        whiteSpace: "pre-line",
                    }}
                >
                    {cta.description}
                </p>
            )}
            {cta.button_label && cta.button_link && (
                <a
                    href={cta.button_link}
                    className="btn btn-light btn-lg px-5 py-3 text-decoration-none"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        fontWeight: "600",
                        letterSpacing: "1px",
                        color: branding.primaryColor,
                        transition: "transform 0.2s, box-shadow 0.2s",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.2)";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "none";
                    }}
                >
                    {cta.button_label}
                </a>
            )}
        </div>
    );
}
